import { Breadcrumb, Card, Col, Row, Typography } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { HeaderSummaryContainer } from '../../archive/components/header-summary.container';
import { HeaderDetailContainer } from '../../archive/components/header-detail.container';
import { SummaryContainer } from '../../archive/components/summary.container';
import { CollapsibleApplicantProfileContainer as ArchivedCollapsibleApplicantProfileContainer } from '../../archive/components/collapsible-applicant-profile.container';
import { RelatedCasesTabContainer } from '../../v1/components/related-cases-tab.container';
import { Helmet } from 'react-helmet';
import { SubPageLayout } from '../../../../staff/sub-page-layout';

const { Title } = Typography;
interface ArchivedSummaryLayoutProps {
  archivedCaseId: string;
  isApplicantSection?: boolean;
}

export const ArchivedSummaryLayout: React.FC<ArchivedSummaryLayoutProps> = (props) => {
  const navigate = useNavigate();
  console.log('archived case id', props.archivedCaseId);
  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          paddingLeft: 24,
          paddingRight: 24
        }}
      >
        <SubPageLayout
          header={
            <div id="leftTitle" style={{ display: 'inline', float: 'left' }}>
              <div style={{ paddingTop: '24px' }}>
                <Breadcrumb
                  className="text-sm"
                  separator="/"
                  items={[
                    {
                      title: (
                        <button
                          onClick={() => navigate(-1)}
                          aria-label="Go back to Cases"
                          className="bg-transparent border-none p-0 cursor-pointer outline-none focus:outline-none active:bg-transparent hover:bg-transparent"
                        >
                           {props.isApplicantSection ? 'Applicants' : 'Cases'}
                        </button>
                      )
                    },
                    { title: 'Send Report' }
                  ]}
                />
              </div>
              <Title level={3} style={{ display: 'inline' }}>
                Send Report
              </Title>
              <span style={{ margin: '0 10px' }}></span>
              <Title level={4} type="secondary" style={{ display: 'inline' }}>
                Send Report
              </Title>
            </div>
          }
        >
          <Helmet>
            <title>Staff Portal</title>
          </Helmet>
            {/* Header Section */}
            <Col span={24}>
          <Col style={{ marginBottom: '20px' }}>
            <HeaderSummaryContainer caseId={props.archivedCaseId} />
            <HeaderDetailContainer caseId={props.archivedCaseId} />
          </Col>
          <Row gutter={16}>
          <Col span={15}>
            <div style={{ marginBottom: '20px' }}>
              <ArchivedCollapsibleApplicantProfileContainer caseId={props.archivedCaseId ?? ''} />
            </div>
            <SummaryContainer archivedCaseId={props.archivedCaseId} />
            <Outlet />
          </Col>
 
          <Col span={9}>
 
            <Card hoverable style={{ marginBottom: '20px' }}>
              <RelatedCasesTabContainer caseId={props.archivedCaseId ?? ''} isArchived={true} />
            </Card>
 
          </Col>
          </Row>
          </Col>
        </SubPageLayout>
      </div>
    </>
  );
};

